import { render, staticRenderFns } from "./CommentsCard.vue?vue&type=template&id=09dd39e1&scoped=true&"
import script from "./CommentsCard.vue?vue&type=script&lang=js&"
export * from "./CommentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd39e1",
  null
  
)

export default component.exports